import { render, staticRenderFns } from "./editProductLabel.vue?vue&type=template&id=7ca22e07&scoped=true"
import script from "./editProductLabel.vue?vue&type=script&lang=js"
export * from "./editProductLabel.vue?vue&type=script&lang=js"
import style0 from "./editProductLabel.vue?vue&type=style&index=0&id=7ca22e07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca22e07",
  null
  
)

export default component.exports